import { render, staticRenderFns } from "./SaleReceiptModal.vue?vue&type=template&id=271fbac6&scoped=true"
import script from "./SaleReceiptModal.vue?vue&type=script&lang=js"
export * from "./SaleReceiptModal.vue?vue&type=script&lang=js"
import style0 from "./SaleReceiptModal.vue?vue&type=style&index=0&id=271fbac6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271fbac6",
  null
  
)

export default component.exports